import React from "react";
import { Reveal } from "@/components/site/Reveal";

// Icon-free, editorial principle cards (matches brand HTML .principle).
export const FeatureGrid = ({ items, columns = 3 }) => {
  const cols = columns === 2 ? "sm:grid-cols-2" : "sm:grid-cols-2 lg:grid-cols-3";
  return (
    <div className={`grid grid-cols-1 ${cols} gap-x-6 gap-y-6`}>
      {items.map((item, i) => (
        <Reveal key={item.title} delay={i * 0.03}>
          <div
            data-testid="capability-card"
            className="h-full rounded-[16px] p-8 transition-colors duration-300"
            style={{ background: "var(--surface)", border: "1px solid var(--card-border)" }}
            onMouseEnter={(e) => (e.currentTarget.style.borderColor = "rgba(140,106,61,0.55)")}
            onMouseLeave={(e) => (e.currentTarget.style.borderColor = "var(--card-border)")}
          >
            <h3 className="text-[16px]" style={{ color: "var(--text)", fontWeight: 500, letterSpacing: "0.2px" }}>{item.title}</h3>
            <p className="mt-3 text-[14px] leading-[1.8]" style={{ color: "var(--muted)" }}>{item.text}</p>
          </div>
        </Reveal>
      ))}
    </div>
  );
};
